import React, { Fragment, useContext, useEffect } from "react";
import Modal from "react-modal";
import scroll from "@threespot/freeze-scroll";

import Icon from "../Icon";
import Crumbs from "./Crumbs";
import Search from "./Search";
import Medications from "./Medications";
import Eligibility from "./Eligibility";
import Apply from "./Apply";
import Resources from "./Resources";
import NoFund from "./NoFund";
import APIError from "../APIError";
import FundReopenNotifications from "../fund-reopen-notifications/FundReopenNotifications";

import { EligibilityContext } from "../../contexts/EligibilityContext";

Modal.setAppElement("body");

const InModal = () => {
  const context = useContext(EligibilityContext);

  useEffect(() => {
    if (context.state.modalOpen) {
      scroll.freeze();
    } else {
      scroll.unfreeze();
    }
  }, [context.state.modalOpen]);

  useEffect(() => {
    const el = document.querySelector(".Modal-overlay");
    if (el) {
      el.scrollTop = 0;
    }
  }, [context.state.step]);

  const Header = () => {
    return (
      <div className="Card-header">
        {context.state.step === 1 && (
          <Fragment>
            <h3 className="Card-title f-h3 c-white">We&rsquo;re here to help</h3>
            <h5 className="Card-subtitle f-h5 f-light c-white u-mb3">with out-of-pocket costs.</h5>
            <p className="Card-text f-light c-white u-mb2">
              Determine your assistance eligibility in 3 easy steps.
            </p>
          </Fragment>
        )}

        <Crumbs />
      </div>
    );
  };

  return (
    <Modal
      isOpen={context.state.modalOpen}
      className="Modal"
      overlayClassName="Modal-overlay"
      onAfterClose={context.actions.reset}
      closeTimeoutMS={600} // timeout must equal CSS animation duration
    >
      <div className="Modal-inner">
        {!context.state.notificationsOptIn && (
          <div className="Card Card--wizard">
            <Header />
            <div className="Card-inner bg-violet-light-50">
              <div className="Card-inner-content">
                {context.state.step === 1 && <Search />}
                {context.state.step === 2 && <Medications />}
                {context.state.step === 3 && <Eligibility />}
                {context.state.step === 4 && <Apply />}
                {context.state.step === 5 && <Resources status="notEligible" />}
                {context.state.step === 6 && <Resources status="closed" />}
                {context.state.step === 7 && (
                  <Resources status="waitListOnly" />
                )}
                {context.state.step === 8 && <NoFund />}
                {context.state.step === 9 && <NoFund noMedication />}
                {context.state.step === 10 && <APIError />}
              </div>
            </div>
          </div>
        )}

        {context.state.notificationsOptIn && (
          <div className="Card">
            <div className="Card-inner bg-violet-light-50">
              <div className="Card-inner-content">
                <FundReopenNotifications
                  inEligibilityWizard
                  data={{
                    fundName: context.state.diseaseFund.name,
                    CareMetxFundId: context.state.diseaseFund.fundId,
                    FundGroupId: context.state.diseaseFund.groupId,
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <ul className="Modal-meta">
          <li className="Modal-meta-item">
            <span className="f-uppercase">Need More Help?</span> Call us at{" "}
            <a className="c-white" href="tel:18663167263">
              1-866-316-7263
            </a>
          </li>
        </ul>

        <button
          type="button"
          onClick={(event) => context.actions.closeModal(event)}
          className="Modal-close"
        >
          <Icon className="Modal-close-icon" name="close" />
          <span className="u-screenreader">Close</span>
        </button>
      </div>
    </Modal>
  );
};

export default InModal;
